module.exports = __webpack_public_path__ + "d79c8678232789dcc7a0855e6f6fd28b.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/menu_icons/Channel.png
// module id = 814
// module chunks = 0